import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HouseGallery from "./houseGallery/HouseGallery";
import "./ServiceDetails.css";
import Details from "./detailsFeature/DetailsFeature";
import { ArrowRightAlt, Schedule } from "@mui/icons-material";
import RightTop from "./rightSection/RightTop";
import {
  fetchedReviewApi,
  fetchedServiceDetailsApi,
  fetchedServicePicApi,
  serviceApi,
  SimilarServiceApi,
} from "../../API/Api";
import GalleryContainer from "./houseGallery/GalleryContainer";
import DescriptionTab from "./Description Tab/DescriptionTab";
import AboutSeller from "./rightSection/AboutSeller";
import Reviewer from "./Reviewer/Reviewer";
import Review from "./Review/Review";
import Portfolio from "./Portfolio/Portfolio";
import SimilarProducts from "./Similar Products/SimilarProducts";
import useChatBot from "../../Custom Hooks/useChatBot";
import ReqNewQuotation from "./rightSection/ReqNewQuotation";
import SocialShare from "../../SocialShare/SocialShare";
import { tokens, fadeInUp } from "../../../store/tokens";

function ServiceDetails() {
  const { refer } = useParams();

  const [serviceDataList, setServiceDataList] = useState([]);
  const [fetchedServiceDetails, setFetchedServiceDetails] = useState({});
  const [scrollH, setScrollH] = useState(0);
  const [fetchedServicePic, setFetchedServicePic] = useState([]);
  const [fetchedSimilarService, setFetchedSimilarService] = useState([]);
  const [fetchedReview, setFetchedReview] = useState([]);
  const [chatOpen, setChatOpen] = useState(false);

  // NOTE: this previously ran on every `scrollH` change, which re-registered
  // a brand new scroll listener on every scroll event (never removing the
  // old ones) — a classic memory-leak/perf bug. Now registers exactly once
  // and cleans up on unmount.
  useEffect(() => {
    const onScroll = () => setScrollH(window.pageYOffset);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // NOTE: this and the details/pic effect below previously depended on
  // `[serviceDataList[0]]` instead of `[refer]`. Since these fetches are
  // keyed by the `refer` URL param, that meant navigating from one service
  // page to another (refer changes, serviceDataList doesn't) would leave
  // stale review data on screen. Fixed to depend on `refer` directly.
  useEffect(() => {
    const formData = new FormData();
    formData.append("page_refer", refer);
    formData.append("action", "fetch");

    fetch(fetchedReviewApi, { method: "POST", body: formData })
      .then((res) => res.json())
      .then((result) => setFetchedReview(result))
      .catch((error) => console.log("ReviewApiError=> ", error));
  }, [refer]);

  useEffect(() => {
    const formData = new FormData();
    formData.append("c_refer", fetchedServiceDetails.c_refer);
    formData.append("seid", fetchedServiceDetails.s_id);
    formData.append("action", "fetch");

    fetch(SimilarServiceApi, { method: "POST", body: formData })
      .then((res) => res.json())
      .then((result) => setFetchedSimilarService(Array.isArray(result) ? result.slice(0, 6) : []))
      .catch((error) => console.log("SimilarServiceApiError=> ", error));
  }, [fetchedServiceDetails.s_id, fetchedServiceDetails.c_refer]);

  useEffect(() => {
    fetch(serviceApi)
      .then((res) => res.json())
      .then((result) => setServiceDataList(Array.isArray(result) ? result : []))
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, []);

  useEffect(() => {
    const formData = new FormData();
    formData.append("pref", refer);
    formData.append("action", "fetch");

    fetch(fetchedServiceDetailsApi, { method: "POST", body: formData })
      .then((res) => res.json())
      .then((result) => setFetchedServiceDetails(result ?? {}))
      .catch((error) => console.log("ServiceDetailsApiError=> ", error));

    fetch(fetchedServicePicApi, { method: "POST", body: formData })
      .then((res) => res.json())
      .then((result) => setFetchedServicePic(Array.isArray(result) ? result : []))
      .catch((error) => console.log("ServicePicApiError=> ", error));
  }, [refer]);

  return (
    <Box
      sx={{
        paddingY: "0px",
        paddingX: { lg: "80px", md: "50px", sm: "30px", xs: "20px" },
        overflow: "hidden",
        position: "relative",
        bgcolor: tokens.bg.page,
      }}
    >
      {useChatBot(
        "service",
        fetchedServiceDetails?.poster_pic,
        fetchedServiceDetails?.agency_logo
          ? fetchedServiceDetails?.agency_logo
          : fetchedServiceDetails?.poster_pic,
        fetchedServiceDetails.agency_title,
        fetchedServiceDetails.agency_refer,
        fetchedServiceDetails?.poster
      )}

      <Grid container columnSpacing={9} mt={0}>
        <Grid item xs={12} md={8} lg={8}>
          <Stack spacing={3}>
            <Box
              sx={{
                borderRadius: `${tokens.radius.lg}px`,
                overflow: "hidden",
                boxShadow: tokens.shadow.sm,
              }}
            >
              <GalleryContainer
                fetchedServicePic={fetchedServicePic}
                fetchedServiceDetails={fetchedServiceDetails}
              />
            </Box>

            <Stack spacing={1} sx={{ width: "100%", display: { xs: "block", md: "none" } }}>
              <RightTop fetchedServiceDetails={fetchedServiceDetails} refer={refer} />
              <ReqNewQuotation refer={refer} />
            </Stack>


            <Stack
              spacing={1}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ ...fadeInUp, animation: "fadeInUp .4s ease both" }}
            >
              <Stack spacing={1} direction="row" justifyContent="left" alignItems="center" flexWrap="wrap">
               
                <Box
                  sx={{
                    paddingX: "10px",
                    paddingY: "2px",
                    bgcolor: tokens.color.successBg,
                    borderRadius: `${tokens.radius.sm}px`,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: tokens.font.body,
                      color: tokens.color.success,
                      fontWeight: 700,
                      fontSize: "0.9rem",
                    }}
                  >
                    {fetchedServiceDetails.total_rating}
                  </Typography>
                </Box>
                <Rating
                  name="read-only"
                  value={parseFloat(fetchedServiceDetails.rating_state) || 0}
                  readOnly
                  sx={{ fontSize: "1.1rem" }}
                />
                {fetchedServiceDetails.review_key?.map((element, index) => (
                  <Button
                    key={element.keyw ?? index}
                    variant="contained"
                    size="small"
                    sx={{
                      textTransform: "capitalize",
                      bgcolor: element.bg_color,
                      color: element.color_c,
                      borderRadius: `${tokens.radius.pill}px`,
                      boxShadow: "none",
                      paddingY: "0px",
                    }}
                  >
                    {element.keyw}
                  </Button>
                ))}
                
              </Stack>

              <SocialShare
                // NOTE: was `"..." + { refer }`, which concatenates the
                // *object* { refer } into the string, producing a literal
                // "[object Object]" in the URL. Fixed to use the refer
                // value itself.
                url={"https://songjukti.com/servicedetails/" + refer}
                title={fetchedServiceDetails?.title}
                hashTag={fetchedServiceDetails?.agency_title}
                description={fetchedServiceDetails?.details?.slice(0, 120)}
              />
            </Stack>
             <Paper
                              elevation={0}
                              sx={{
                                p: 4,
                                border: `1px solid ${tokens.color.line}`,
                                boxShadow: tokens.shadow.md,
                                bgcolor: tokens.bg.surface,
                              }}
                            > 

            <Stack sx={{ ...fadeInUp, animation: "fadeInUp .45s ease both" }}>
              <Typography
                sx={{
                  fontFamily: tokens.font.heading,
                  fontSize: { xs: "1.5rem", md: "1.9rem" },
                  fontWeight: 700,
                  color: tokens.textOn.light.primary,
                }}
              >
                {fetchedServiceDetails.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: tokens.font.body,
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: tokens.textOn.light.secondary,
                }}
              >
                Dhaka, Bangladesh
              </Typography>
            </Stack>

            <Stack direction="row" spacing={0.5} justifyContent="left" alignItems="center">
              <Typography sx={{ fontFamily: tokens.font.body, fontSize: "0.95rem", fontWeight: 600, color: tokens.textOn.light.primary }}>
                {fetchedServiceDetails.jcategory}
              </Typography>
              <ArrowRightAlt sx={{ fontSize: "1.1rem", color: tokens.textOn.light.secondary }} />
              <Typography sx={{ fontFamily: tokens.font.body, fontSize: "0.95rem", fontWeight: 600, color: tokens.textOn.light.primary }}>
                {fetchedServiceDetails.jsubcat}
              </Typography>
            </Stack>

            <Stack spacing={0.5} direction="row" justifyContent="left" alignItems="center">
              <Schedule sx={{ fontSize: "1.1rem", color: tokens.color.teal }} />
              <Typography sx={{ fontFamily: tokens.font.body, fontSize: "0.95rem", fontWeight: 600, color: tokens.textOn.light.primary }}>
                {fetchedServiceDetails.jschedule}
              </Typography>
            </Stack>

            </Paper>

            <Divider sx={{ borderColor: tokens.color.line }} />

            <DescriptionTab fetchedServiceDetails={fetchedServiceDetails} />
            <AboutSeller fetchedServiceDetails={fetchedServiceDetails} setChatOpen={setChatOpen} />
            <Details fetchedServiceDetails={fetchedServiceDetails} />
            <Portfolio s_id={fetchedServiceDetails.s_id} />
            <Review fetchedReview={fetchedReview} />
            {fetchedReview.review_data?.map(
              (element, index) =>
                element.type === "service" && (
                  <Reviewer
                    key={element.refer ?? index}
                    refer={refer}
                    fetchedReviewItem={element}
                    fetchedReviewList={fetchedReview.review_data}
                  />
                )
            )}
            <SimilarProducts fetchedSimilarService={fetchedSimilarService} />
          </Stack>
        </Grid>

        <Grid item xs={12} md={4} lg={4} sx={{ display: { xs: "none", md: "block" } }}>
          <Stack
            spacing={1.5}
            sx={{
              position: "fixed",
              top: "24%",
              width: "28%",
              right: "6%",
              transition: "all 0.1s",
            }}
            className={scrollH > 90 ? "translate" : ""}
          >
            {/* <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: `${tokens.radius.lg}px`,
                border: `1px solid ${tokens.color.line}`,
                boxShadow: tokens.shadow.md,
                bgcolor: tokens.bg.surface,
              }}
            > */}
              <Stack spacing={1.5}>
                <RightTop fetchedServiceDetails={fetchedServiceDetails} refer={refer} />
                <ReqNewQuotation refer={refer} />
              </Stack>
            {/* </Paper> */}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ServiceDetails;